import { render } from "./CustomerStoryCard.vue?vue&type=template&id=45226dc8"
import script from "./CustomerStoryCard.vue?vue&type=script&lang=js"
export * from "./CustomerStoryCard.vue?vue&type=script&lang=js"

import "./CustomerStoryCard.vue?vue&type=style&index=0&id=45226dc8&lang=scss"

import exportComponent from "/home/runner/work/intelli-landing-frontend/intelli-landing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__